import { render, staticRenderFns } from "./AtomImageRectangularForCard.vue?vue&type=template&id=7adff617&scoped=true"
import script from "./AtomImageRectangularForCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AtomImageRectangularForCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adff617",
  null
  
)

export default component.exports